/**
 * Shared prefix used to build `completeKey` values for space-settings web items
 * that are injected by the Confluence frontend (as opposed to server-rendered or plugin items).
 *
 * Defined once here to prevent silent breakage if the prefix ever changes.
 */
export const SPACE_PERMISSIONS_COMPLETE_KEY = 'confluence-frontend.';
